import { CREATE_UNDERGONE_SURGERY_FAIL, CREATE_UNDERGONE_SURGERY_REQUEST, CREATE_UNDERGONE_SURGERY_SUCCESS, FETCH_UNDERGONE_SURGERY_FAIL, FETCH_UNDERGONE_SURGERY_REQUEST, FETCH_UNDERGONE_SURGERY_SUCCESS, UPDATE_UNDERGONE_SURGERY_FAIL, UPDATE_UNDERGONE_SURGERY_REQUEST, UPDATE_UNDERGONE_SURGERY_SUCCESS } from "../../ActionType/UndergoneSurgeryTypes/UndergoneSurgeryTypes";

export const createUnderGoneSurgeryReducer = (
    state = { loading: true, surgeries: undefined, error: "" },
    action
  ) => {
    switch (action.type) {
      case CREATE_UNDERGONE_SURGERY_REQUEST:
        return {
          loading: true,
          visits: [],
        };
      case CREATE_UNDERGONE_SURGERY_SUCCESS:
     
        return {
          loading: false,
          surgeries: action.payload,
          error: "",
        };
      case CREATE_UNDERGONE_SURGERY_FAIL:
        return {
          loading: false,
          surgeries: [],
          error: action.error,
        };
      default:
        return state;
    }
  };
  
  export const getUndergoneSurgeryReducer = (
    state = { loading: true, surgeries: [], total: "", error: "" },
    action
  ) => {
    switch (action.type) {
      case FETCH_UNDERGONE_SURGERY_REQUEST:
        return {
          loading: true,
          visits: [],
        };
      case FETCH_UNDERGONE_SURGERY_SUCCESS:
        return {
          loading: false,
          surgeries: action.payload.data,
          total: action.payload.total,
          error: "",
        };
      case FETCH_UNDERGONE_SURGERY_FAIL:
        return {
          loading: false,
          surgeries: [],
          error: action.error,
        };
      default:
        return state;
    }
  };

  export const updateUndergoneSurgeryReducer = (
    state = { loading: true, surgeries: [], total: "", error: "" },
    action
  ) => {
    switch (action.type) {
      case UPDATE_UNDERGONE_SURGERY_REQUEST:
        return {
          loading: true,
          visits: [],
        };
      case UPDATE_UNDERGONE_SURGERY_SUCCESS:
        return {
          loading: false,
          surgeries: action.payload.data,
          total: action.payload.total,
          error: "",
        };
      case UPDATE_UNDERGONE_SURGERY_FAIL:
        return {
          loading: false,
          surgeries: [],
          error: action.error,
        };
      default:
        return state;
    }
  };